"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  PRODUCT: 'product'
};
exports.default = _default;
module.exports = exports.default;